import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';
import { ActionItemType } from '../../DomainEnums';

export type DropdownOptions = {
  id: string;
  name: string;
  iconUrl: string;
};
type DropDownProperties = {
  selectedItem?: DropdownOptions | null;
  options: DropdownOptions[];
  handleOption: (item: DropdownOptions) => void;
};
const WORK_ITEM_MODEL = { iconUrl: '', id: '', name: ActionItemType.TEXT_NOTE };
export const MONDAY_ITEM = [
  {
    iconUrl: '',
    id: '',
    name: ActionItemType.MONDAY_ITEM,
  },
];

const isMonday = (type: string) => type === MONDAY_ITEM[0].name;

function ActiveItem({ item }: { item: DropdownOptions }) {
  const isMondayItem = MONDAY_ITEM[0].name === item.name;

  if (isMondayItem) {
    return (
      <>
        <S.MondayIcon key="MondayIcon" />
        <S.TriggerDropdownCaret key="TriggerDropdownCaret" />
      </>
    );
  }

  return (
    <>
      <S.DropdownItemIcon
        key="DropdownItemIcon"
        src={item?.iconUrl}
        alt={item?.name}
      />
      <S.TriggerDropdownCaret key="TriggerDropdownCaret" />
    </>
  );
}

function useHandleClickOutside(
  wrapperReference: React.RefObject<HTMLDivElement>,
  callback: () => void
) {
  useEffect(() => {
    const wrapperElement = wrapperReference.current;

    function handleClickOutside(event: any) {
      if (wrapperElement && !wrapperElement.contains(event.target)) {
        callback();
      }
    }

    if (wrapperElement) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => {
      if (wrapperElement) {
        document.removeEventListener('click', handleClickOutside);
      }
    };
  }, [callback, wrapperReference]);
}

function DropDownNew({
  selectedItem,
  options,
  handleOption,
}: DropDownProperties) {
  const wrapperReference = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [itemActive, setItemActive] = useState<DropdownOptions | null>(
    selectedItem || null
  );

  function closeDropdown() {
    setOpen(false);
  }

  useHandleClickOutside(wrapperReference, closeDropdown);

  useEffect(() => {
    handleOption(itemActive || WORK_ITEM_MODEL);
  }, [handleOption, itemActive]);

  return (
    <S.Wrapper onClick={() => setOpen(!open)} data-testid="dropDownNew">
      <S.Trigger ref={wrapperReference}>
        {itemActive ? (
          <ActiveItem item={itemActive} />
        ) : (
          <>
            <S.TextNoteIcon key="TextNoteIcon" />
            <S.TriggerDropdownCaret key="TriggerDropdownCaret" />
          </>
        )}

        <S.Dropdown isOpen={open}>
          {options.map((item) =>
            isMonday(item.name) ? (
              <S.DropdownItem
                onClick={() => setItemActive(item)}
                key={item.name + item.id}
              >
                <S.MondayIcon />
                Item
              </S.DropdownItem>
            ) : (
              <S.DropdownItem
                onClick={() => setItemActive(item)}
                key={item.name + item.id}
              >
                {item.iconUrl && (
                  <S.DropdownItemIcon src={item.iconUrl} alt={item.name} />
                )}

                <S.DropdownItemLabel>{item.name}</S.DropdownItemLabel>
              </S.DropdownItem>
            )
          )}
          <S.DropdownItem textNote onClick={() => setItemActive(null)}>
            <S.TextNoteIcon />
            Plain Text
          </S.DropdownItem>
        </S.Dropdown>
      </S.Trigger>
    </S.Wrapper>
  );
}

export default DropDownNew;
